


<p>test!</p>

 <div *ngFor="let hm of heatmap$ | async">
      {{hm.street_address}}

      {{hm.subdivision_name}}
</div>